import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAffinityphotoComponent } from './simple-icons-affinityphoto.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAffinityphotoComponent ],
    exports:      [ SimpleIconsAffinityphotoComponent ],
    bootstrap:    []
})
export class SimpleIconsAffinityphotoModule {}
